import { useEffect } from "react";

/**
 * Runs the provided effect only once on mount and cleans up on unmount.
 * This mirrors legacy componentDidMount/componentWillUnmount behavior
 * without forcing every caller to manage an empty dependency array.
 */
export const useMountEffect = (effect: () => void | (() => void)): void => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(effect, []);
};
